import { Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { OrderWizardService } from "../../_service/order-wizard.service";
import { CorpLoadingComponent } from "@corporate-tailwind/component";
import { CommonModule } from "@angular/common";
import { ItsMeCustomerSummaryComponent } from "../../step-03/itsme-login/customer-summary/itsme-customer-summary.component";
import { PickupPointCardSummaryComponent } from "../../step-02/pickup-point/card-summary/pickup-point-card-summary.component";
import { OrderPurchaseSummaryComponent } from "../../step-01/summary/order-purchase-summary.component";

@Component({
    selector: 'order-wizard-summary',
    imports: [CommonModule, TranslateModule, CorpLoadingComponent, OrderPurchaseSummaryComponent, PickupPointCardSummaryComponent, ItsMeCustomerSummaryComponent],
    templateUrl: './order-wizard-summary.component.html',
    styleUrls: ['./order-wizard-summary.component.scss'],
    animations: [ ]
})
export class OrderWizardSummaryComponent implements OnInit, OnDestroy {

    constructor(
        public _orderWizardService: OrderWizardService,
    ) {
        // this.pickupPoint = this._orderWizardService.getValue(x=>x.step02);
    }


    ngOnInit(): void {

    }

    ngOnDestroy(): void {

    }

}